import { createDeformedCube, depthRatio ,CUBE_PARAMS } from "./CubeBase";

// 誤り4: 垂直辺の傾き誤り
// 歪んだ他の辺同士をつなぎ合わせるために、垂直であるべき奥の辺（文献の辺E）を
// 左に傾けて描く誤り。奥の頂点のうち、右奥下の頂点のみが右にずれる形で誤りを作る。
// shearValue: 0=正解(立方体), 0.5=誤り, 0.2=中間
export function createCubeModel4(shearValue, faceColors, errorEdges) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const half = CUBE_PARAMS.size / 2;
  return createDeformedCube((x, y, z) => [
    //右奥下の頂点のみが右にずれる
    x - (z > 0 && y < 0 ? 0.6*shearValue * depthRatio(z) * half : 0),
    y,
    z,
  ], faceColors, errorEdges);
}
